export default {
  "trigger": "Punteggio per voce",
  "examplesButton": "Cosa posso dire?",
  "example": "“ {first} uno sopra, {second} birdie”",
  "title": "PUNTEGGIO VOCALE",
  "states": {
    "requesting_permission": "Preparare il microfono...",
    "listening": "Ascoltare...",
    "processing_recording": "Registrazione di elaborazione...",
    "transcribing": "Transcribing...",
    "interpreting": "Capire i tuoi punteggi...",
    "review": "Controlla questi punteggi",
    "error": "Voce punteggio"
  },
  "cancel": "Annulla",
  "done": "Fine",
  "heard": "Ho sentito: “ {transcript} ”",
  "strokes": "colpi",
  "decrease": "Diminuzione {name} punteggio proposto",
  "increase": "Aumentare {name} punteggio proposto",
  "labels": {
    "holeInOne": "Buca in uno",
    "albatross": "Albatros",
    "eagle": "Aquila",
    "birdie": "Uccelli",
    "par": "Pari",
    "bogey": "Bogey",
    "doubleBogey": "Doppia bogey",
    "tripleBogey": "Tripla bogey"
  },
  "correction": "Correzione udita: “ {phrase} ”",
  "repair": "Interpretazione confermata: “ {original} ” è stato inteso come “ {replacement} ”.",
  "repairSuggestion": "Possibile interpretazione: “ {original} ” può significare “ {replacement} ”. Confermare i colpi effettivi qui sotto.",
  "subset": "Solo i punteggi compresi saranno applicati. Le voci non risolte non saranno salvate.",
  "retry": "Riprova",
  "apply": "Applicare i punteggi",
  "applySubset": "Applicare i punteggi compresi",
  "manual": "Utilizzare il punteggio manuale",
  "clarification": "Bisogno di chiarificazione",
  "player": "Giocatore",
  "choosePlayer": "Scegli un giocatore",
  "gross": "Ictus lordi",
  "confirmEntry": "Confermare questo punteggio",
  "skip": "Lasciare la voce fuori",
  "errors": {
    "interpretationFailure": "Non abbiamo potuto interpretare quei punteggi. Provare di nuovo o utilizzare il punteggio manuale.",
    "unavailable": "Il punteggio vocale non è disponibile in questo momento. Si prega di utilizzare il punteggio manuale.",
    "microphone_permission_denied": "L'accesso al microfono è disattivato per Privana . Impostazioni del dispositivo aperto, abilitare Microfono per Privana , quindi riprovare.",
    "microphone_unavailable": "Non abbiamo potuto accedere al microfono. Prova di nuovo.",
    "media_recorder_unavailable": "La registrazione vocale non è supportata su questo dispositivo.",
    "empty_audio": "Non abbiamo preso alcun audio.",
    "unsupported_audio": "Questo dispositivo ha registrato un formato audio non supportato.",
    "upload_failed": "Non potevamo inviare quella registrazione. Controlla la tua connessione e riprova.",
    "no_speech": "Non abbiamo preso nessun discorso.",
    "transcription_failed": "Non siamo riusciti a trascrivere questo. Prova di nuovo.",
    "voice_timeout": "Il punteggio vocale ha richiesto troppo tempo. Prova di nuovo o usa il punteggio manuale.",
    "recording_failed": "Non siamo riusciti a registrare la tua voce.",
    "saveFailure": "Alcuni punteggi non potrebbero essere in coda. Mantenere questa recensione aperta e riprovare."
  }
}
